import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { useFeature } from '@treams/treams-hooks/useFeature';
import * as graphql from '@treams/treams-network';
import { Switch } from '@treams/treams-ui/common/Switch';

import Property from './Property';

export default function RequiredToggle() {
	const { t } = useTranslation();

	const optionalQuestionsEnabled = useFeature(graphql.FeatureName.ConversationsOptionalQuestions);

	const [field, , { setValue }] = useField('optional');

	const isRequired = !field.value;

	if (!optionalQuestionsEnabled) {
		return null;
	}

	return (
		<Property title={t('common.settings.evaluationForms.properties.required.title')}>
			<Switch
				label={t('common.settings.evaluationForms.properties.required.label')}
				on={isRequired}
				onChange={() => setValue(!field.value)}
			/>
		</Property>
	);
}
